import { z } from 'zod';
import type {
  GetCoverShipmentRequest,
  GetCoverShipmentResponse,
} from './get-cover-shipment.dto.js';
import { CoverShipmentDetailSchema } from './cover-shipments-shared.schema.js';

export const GetCoverShipmentRequestSchema: z.ZodType<GetCoverShipmentRequest> = z
  .object({
    companyId: z.uuid(),
    coverShipmentId: z.uuid(),
  })
  .strict();

export const GetCoverShipmentResponseSchema: z.ZodType<GetCoverShipmentResponse> = z
  .object({
    coverShipment: CoverShipmentDetailSchema,
  })
  .strict();
